export default __webpack_public_path__ + "static/media/down.dd51fbb1.png";